document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".delivery-wrapper");
  if (!wrapper) return;

  const API_BASE = "https://web-production-bcae2.up.railway.app";

  const input = wrapper.querySelector(".delivery-pincode-input");
  const changeBtn = wrapper.querySelector(".delivery-change-btn");
  const message = wrapper.querySelector(".delivery-message");
  const locationEl = wrapper.querySelector(".delivery-location");

  const savedPin = localStorage.getItem("user_pincode");
  if (savedPin && /^[0-9]{6}$/.test(savedPin)) {
    input.value = savedPin;
    fetchDelivery(savedPin);
  }

  input.addEventListener("input", function () {
    if (input.value.trim() === "") {
      message.innerHTML = "";
      if (locationEl) locationEl.innerHTML = "";
      return;
    }
    if (input.value !== localStorage.getItem("user_pincode")) {
      message.innerHTML = "";
      if (locationEl) locationEl.innerHTML = "";
    }
  });

  changeBtn.addEventListener("click", function () {
    const pin = input.value.trim();
    if (!/^[0-9]{6}$/.test(pin)) {
      message.innerHTML = "Please enter a valid 6-digit pincode.";
      if (locationEl) locationEl.innerHTML = "";
      return;
    }
    localStorage.setItem("user_pincode", pin);
    fetchDelivery(pin);
  });

  async function fetchDelivery(pin) {
    message.innerHTML = "Checking...";
    if (locationEl) locationEl.innerHTML = "";

    try {
      const response = await fetch(`${API_BASE}/check/${pin}`);
      const data = await response.json();

      if (!data.serviceable) {
        message.innerHTML = "We currently do not deliver to this pincode.";
        if (locationEl) locationEl.innerHTML = "";
        return;
      }

      const options = { day: "numeric", month: "short", year: "numeric" };

      const stdDate = new Date();
      stdDate.setDate(stdDate.getDate() + data.delivery_max);
      const stdLabel = stdDate.toLocaleDateString("en-IN", options);

      const boxBase = "display:block;padding:8px 12px;border-radius:4px;margin-bottom:8px;line-height:1.5;font-size:0.9em;";
      const headerStyle = "display:flex;justify-content:space-between;align-items:center;margin-bottom:2px;";
      const typeStyle = "font-size:13px;color:#555;";
      const dateStyle = "font-size:14px;font-weight:700;color:#111;";

      let html =
        "<span style='" + boxBase + "border-left:3px solid #2e7d52;background:#f2faf6;'>" +
        "<span style='" + headerStyle + "'>" +
        "<span style='" + typeStyle + "'>Standard delivery</span>" +
        "<span style='font-size:11px;font-weight:700;padding:2px 8px;border-radius:20px;background:#d4edda;color:#1a5e28;'>FREE</span>" +
        "</span>" +
        "<span style='" + dateStyle + "'>" + stdLabel + "</span>" +
        "</span>";

      if (data.express_tat && data.express_tat < data.delivery_max) {
        const expDate = new Date();
        expDate.setDate(expDate.getDate() + data.express_tat);
        const expLabel = expDate.toLocaleDateString("en-IN", options);
        html +=
          "<span style='" + boxBase + "border-left:3px solid #c89b00;background:#fffcf0;'>" +
          "<span style='" + headerStyle + "'>" +
          "<span style='" + typeStyle + "'>Express delivery</span>" +
          "<span style='font-size:11px;font-weight:700;padding:2px 8px;border-radius:20px;background:#fff3cd;color:#856404;'>PREMIUM</span>" +
          "</span>" +
          "<span style='" + dateStyle + "'>" + expLabel + "</span>" +
          "</span>";
      }

      message.innerHTML = html;

      if (locationEl) {
        locationEl.innerHTML = data.district
          ? "<span style='font-size:1em;color:#2e7d52;'>✓ Delivering to " + data.district + "</span>"
          : "";
      }

    } catch (error) {
      message.innerHTML = "Unable to check delivery right now.";
      if (locationEl) locationEl.innerHTML = "";
    }
  }
});
